import ChecklistThemeComponent, {
  ChecklistThemeComponentProps,
} from './ChecklistThemeComponent';

export default ChecklistThemeComponent;

export type { ChecklistThemeComponentProps };
